import React, { useEffect, useState } from 'react';
import { Button, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Countdown, { zeroPad } from 'react-countdown';
import { postRequestWithoutAccessToken } from '../../helpers/apiHandler';
import CustomAlert from '../../components/CustomAlert';
import config from '../../config/Constant';
import EmailIcon from '../../assets/email-verification-icon.svg';

const ResetPasswordSuccess = props => {
  const history = useNavigate();
  const getDataCache = localStorage.getItem('reset_password_data');
  const getData = getDataCache !== null ? JSON.parse(getDataCache) : null;

  const [disabled, setDisabled] = useState(true);
  const [loading, setLoading] = useState(false);

  const [alertState, setAlertState] = useState({
    show: false,
    variant: 'danger',
    message: '',
  });

  const resendResetPasswordLink = () => {
    setLoading(true);
    postRequestWithoutAccessToken('/auth/request-password-reset', { email: getData.email }, res => {
      if (!res.error) {
        window.location.reload();
      } else {
        setAlertState({
          show: true,
          variant: 'danger',
          message: res.message,
        });
      }
      setLoading(false);
    });
  };

  useEffect(() => {
    if (getData === null) {
      history('/login');
    }
  }, []);

  useEffect(() => {
    if (alertState.show) {
      setTimeout(() => {
        setAlertState({
          message: '',
          show: false,
          variant: '',
        });
      }, config.notify_time);
    }
  }, [alertState]);

  return (
    <div className="Authenticate ResetPasswordSuccess">
      <CustomAlert
        message={alertState.message}
        show={alertState.show}
        variant={alertState.variant}
        closeAlert={() => setAlertState({ show: false, variant: 'danger', message: '' })}
      />
      <div className="account-activation-wrapper">
        <div className="account-activation">
          <img alt="..." src={EmailIcon} />
          <h3>Check your inbox</h3>
          <p>
            We've dispatched a password reset link to your email address:{' '}
            <strong>{getData.email}</strong>
            <br />
            Should it not arrive within 5 minutes, kindly inspect your spam folder. Alternatively,
            you
            <br />
            can click here to initiate a resend.
          </p>
          <Button
            variant="primary"
            onClick={resendResetPasswordLink}
            style={{ minWidth: 160 }}
          >
            Resend Reset Link
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordSuccess;
